import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { StudyCB } from './StudyCB';
import NoVisaInformation from '@/presentation/components/no-visa-information/NoVisaInformation.vue';
import NoVisaRequired from '@/presentation/components/no-visa-required/NoVisaRequired.vue';

export default defineComponent({
	setup: () => {
		const codeBehind = new StudyCB();

		return setupComponent(codeBehind);
	},
	components: {
		NoVisaRequired,
		NoVisaInformation,
	},
});
